import { TriangleAlert } from "lucide-react"
import { cn } from "@/lib/utils"

/**
 * Warning shown when a piece is still `scheduled` but its publish time is in
 * the past — it missed its slot and needs the operator's attention. Gate the
 * render on `isSchedulePastDue` (see @/lib/scheduling). Size/spacing is left
 * to the caller via `className` so it fits both the small calendar/pipeline
 * cards and the piece detail view.
 */
export function PastDueWarning({
  message,
  className,
}: {
  message: string
  className?: string
}) {
  return (
    <span
      role="alert"
      className={cn("inline-flex items-center gap-1 font-medium text-signal-display", className)}
    >
      <TriangleAlert className="size-3.5 shrink-0" aria-hidden />
      <span>{message}</span>
    </span>
  )
}
